import React, { Component, Fragment, useEffect, useState } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Dialog from '@material-ui/core/Dialog';

import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { CustomMessageDialogStyles } from '../../styles/CustomStyles';
import { AppConfig } from '../../AppConfig';
import { Helper } from '../helpers/Helper';
import { AppButton } from './AppButton';
import { UiHelper } from '../helpers/UiHelper';

export function ActionDialog(props) {

  const [inProcess, setInProcess] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  const doAction = async () => {
    setInProcess(true)
    setErrMsg(null)
    try {
      const resp = await props.doAction()
      setInProcess(false)
      props.onSuccessCallback()
    } catch (err) {
      setErrMsg(Helper.getErrorMsg(err))
      setInProcess(false)
    }
  }

  return (
    <Dialog
      open={props.isOpen}
      aria-labelledby={props.title}
      fullWidth={false}
      maxWidth='md'
      classes={{
        root: css(Styles.root),
        paper: css(Styles.paper),
      }}
    >
      <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
        <div className={css(Styles.modalTitle)}>{props.title}</div>
        <button className={css(Styles.modalCloseButton)} onClick={() => props.onClose()} disabled={inProcess}>
          {UiHelper.renderImg({key:'dialogCloseIcon'})}
        </button>
      </div>
      <div className={css(Styles.modalContent)}>
        {props.children}
        <div className={css(Styles.buttonContainer)}>
          {errMsg &&
            <p className={css(Styles.errMsg)}>{errMsg}</p>
          }
          <AppButton
            disabled={inProcess}
            inProcess={inProcess}
            onClick={doAction}
            buttonText={props.buttonText || Helper.getString('submit')}
          />
        </div>
      </div>
    </Dialog>
  );
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: '#222222',
    fontSize: 26,
  },
  modalContent: {
    maxWidth: 400,
    minWidth: 200,
    paddingTop: 0,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    fill: AppTheme.primaryColor,
    borderRadius: AppTheme.borderRadius
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 10
  },
  errMsg: {
    margin: 0,
    color: 'red',
    fontSize: 14,
    marginRight: 10
  }
})



// WEBPACK FOOTER //
// ./src/common/components/ActionDialog.js